import script from "./rightFixed.vue?vue&type=script&setup=true&lang=js"
export * from "./rightFixed.vue?vue&type=script&setup=true&lang=js"

import "./rightFixed.vue?vue&type=style&index=0&id=20c9d19e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20c9d19e"]])

export default __exports__